import gql from 'graphql-tag';

export const GET_ORGANISATION = gql`
  query Organisation (
    $id: ID,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $keyName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String,
    $type: String
  ) {
    Organisation(
      id: $id
      dpid: $dpid,
      isni: $isni,
      ipi: $ipi,
      ipn: $ipn,
      musicbrainzGuid: $musicbrainzGuid,
      cisacSocietyID: $cisacSocietyID,
      fullName: $fullName,
      keyName: $keyName,
      abbreviatedName: $abbreviatedName,
      description: $description,
      postalAddressLine: $postalAddressLine,
      postalCityName: $postalCityName,
      postalDistrictName: $postalDistrictName,
      postCode: $postCode,
      postalTerritoryCode: $postalTerritoryCode,
      phoneNumber: $phoneNumber,
      emailAddress: $emailAddress,
      website: $website,
      type: $type
    ) {
      id,
      dpid,
      isni,
      ipi,
      ipn,
      musicbrainzGuid,
      cisacSocietyID,
      fullName,
      keyName,
      abbreviatedName,
      description,
      postalAddressLine,
      postalCityName,
      postalDistrictName,
      postCode,
      postalTerritoryCode,
      phoneNumber,
      emailAddress,
      website,
      type,
      releases {
        release {
          id,
          title,
          type,
          isMainRelease,
          releaseDetails {
            id,
            artwork {
              id,
              file {
                uri
              }
            }
          }
        }
      }
      assets {
        __typename
        ...on Project {
          id,
          title
        }
        ...on Share {
          id,
          percent,
          territoryCode,
          work {
            id,
            title
          }
        }
        ...on ReleaseDetail {
          release {
            id,
            title,
            type,
            isMainRelease,
            releaseDetails {
              id,
              artwork {
                id,
                file {
                  uri
                }
              }
            }
          }
        }
      }
      rightsControlled {
        id,
        percent,
        territoryCode,
        work {
          id,
          title
        }
      }
      rightsAdministered {
        id,
        percent,
        territoryCode,
        work {
          id,
          title
        }
      }
      contributions {
        id,
        role,
        featured,
        contracted,
        isCredited,
        contributedTo {
          __typename
          ...on Component {
            id,
            title
          }
          ...on Work {
            id,
            title
          }

        }
      }
    }
  }
`;

export const CREATE_ORGANISATION = gql`
  mutation createOrganisation (
    $id: ID,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $keyName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String,
    $type: String
  ) {
    CreateOrganisation(
      id: $id
      dpid: $dpid,
      isni: $isni,
      ipi: $ipi,
      ipn: $ipn,
      musicbrainzGuid: $musicbrainzGuid,
      cisacSocietyID: $cisacSocietyID,
      fullName: $fullName,
      keyName: $keyName,
      abbreviatedName: $abbreviatedName,
      description: $description,
      postalAddressLine: $postalAddressLine,
      postalCityName: $postalCityName,
      postalDistrictName: $postalDistrictName,
      postCode: $postCode,
      postalTerritoryCode: $postalTerritoryCode,
      phoneNumber: $phoneNumber,
      emailAddress: $emailAddress,
      website: $website,
      type: $type
    ) {
      id,
      dpid,
      isni,
      ipi,
      ipn,
      musicbrainzGuid,
      cisacSocietyID,
      fullName,
      keyName,
      abbreviatedName,
      description,
      postalAddressLine,
      postalCityName,
      postalDistrictName,
      postCode,
      postalTerritoryCode,
      phoneNumber,
      emailAddress,
      website,
      type
    }
  }
`;

export const UPDATE_ORGANISATION = gql`
  mutation updateOrganisation (
    $id: ID!,
    $dpid: String,
    $isni: String,
    $ipi: String,
    $ipn: String,
    $musicbrainzGuid: String,
    $cisacSocietyID: String,
    $fullName: String,
    $keyName: String,
    $abbreviatedName: String,
    $description: String,
    $postalAddressLine: String,
    $postalCityName: String,
    $postalDistrictName: String,
    $postCode: String,
    $postalTerritoryCode: String,
    $phoneNumber: String,
    $emailAddress: String,
    $website: String,
    $type: String
  ) {
    UpdateOrganisation(
      id: $id
      dpid: $dpid,
      isni: $isni,
      ipi: $ipi,
      ipn: $ipn,
      musicbrainzGuid: $musicbrainzGuid,
      cisacSocietyID: $cisacSocietyID,
      fullName: $fullName,
      keyName: $keyName,
      abbreviatedName: $abbreviatedName,
      description: $description,
      postalAddressLine: $postalAddressLine,
      postalCityName: $postalCityName,
      postalDistrictName: $postalDistrictName,
      postCode: $postCode,
      postalTerritoryCode: $postalTerritoryCode,
      phoneNumber: $phoneNumber,
      emailAddress: $emailAddress,
      website: $website,
      type: $type
    ) {
      id,
      dpid,
      isni,
      ipi,
      ipn,
      musicbrainzGuid,
      cisacSocietyID,
      fullName,
      keyName,
      abbreviatedName,
      description,
      postalAddressLine,
      postalCityName,
      postalDistrictName,
      postCode,
      postalTerritoryCode,
      phoneNumber,
      emailAddress,
      website,
      type
    }
  }
`;

export const DELETE_ORGANISATION = gql`
  mutation deleteOrganisation (
    $id: ID!
  ) {
  DeleteOrganisation(
    id: $id
  ) {
    id
  }
}
`;


// AddOrganisationTextDepictions(
//   from: _TextInput!
//   to: _OrganisationInput!
// ): _AddOrganisationTextDepictionsPayload
// RemoveOrganisationTextDepictions(
//   from: _TextInput!
//   to: _OrganisationInput!
// ): _RemoveOrganisationTextDepictionsPayload
// AddOrganisationImageDepictions(
//   from: _ImageInput!
//   to: _OrganisationInput!
// ): _AddOrganisationImageDepictionsPayload
// RemoveOrganisationImageDepictions(
//   from: _ImageInput!
//   to: _OrganisationInput!
// ): _RemoveOrganisationImageDepictionsPayload
// AddOrganisationVideoDepictions(
//   from: _VideoInput!
//   to: _OrganisationInput!
// ): _AddOrganisationVideoDepictionsPayload
// RemoveOrganisationVideoDepictions(
//   from: _VideoInput!
//   to: _OrganisationInput!
// ): _RemoveOrganisationVideoDepictionsPayload
// AddOrganisationProjects(
//   from: _OrganisationInput!
//   to: _ProjectInput!
// ): _AddOrganisationProjectsPayload
// RemoveOrganisationProjects(
//   from: _OrganisationInput!
//   to: _ProjectInput!
// ): _RemoveOrganisationProjectsPayload
// AddOrganisationContributions(
//   from: _OrganisationInput!
//   to: _ContributionInput!
// ): _AddOrganisationContributionsPayload
// RemoveOrganisationContributions(
//   from: _OrganisationInput!
//   to: _ContributionInput!
// ): _RemoveOrganisationContributionsPayload
// AddOrganisationWorksPublished(
//   from: _OrganisationInput!
//   to: _WorkInput!
// ): _AddOrganisationWorksPublishedPayload
// RemoveOrganisationWorksPublished(
//   from: _OrganisationInput!
//   to: _WorkInput!
// ): _RemoveOrganisationWorksPublishedPayload
// AddOrganisationReleases(
//   from: _OrganisationInput!
//   to: _ReleaseDetailInput!
// ): _AddOrganisationReleasesPayload
// RemoveOrganisationReleases(
//   from: _OrganisationInput!
//   to: _ReleaseDetailInput!
// ): _RemoveOrganisationReleasesPayload
// AddOrganisationReleasesOwned(
//   from: _OrganisationInput!
//   to: _ReleaseDetailInput!
// ): _AddOrganisationReleasesOwnedPayload
// RemoveOrganisationReleasesOwned(
//   from: _OrganisationInput!
//   to: _ReleaseDetailInput!
// ): _RemoveOrganisationReleasesOwnedPayload
// AddOrganisationRightsShares(
//   from: _OrganisationInput!
//   to: _ShareInput!
// ): _AddOrganisationRightsSharesPayload
// RemoveOrganisationRightsShares(
//   from: _OrganisationInput!
//   to: _ShareInput!
// ): _RemoveOrganisationRightsSharesPayload
// AddOrganisationRightsControlled(
//   from: _OrganisationInput!
//   to: _ShareInput!
// ): _AddOrganisationRightsControlledPayload
// RemoveOrganisationRightsControlled(
//   from: _OrganisationInput!
//   to: _ShareInput!
// ): _RemoveOrganisationRightsControlledPayload
// AddOrganisationRightsAdministered(
//   from: _OrganisationInput!
//   to: _ShareInput!
// ): _AddOrganisationRightsAdministeredPayload
// RemoveOrganisationRightsAdministered(
//   from: _OrganisationInput!
//   to: _ShareInput!
// ): _RemoveOrganisationRightsAdministeredPayload
// AddOrganisationInstrumentsMade(
//   from: _InstrumentInput!
//   to: _OrganisationInput!
// ): _AddOrganisationInstrumentsMadePayload
// RemoveOrganisationInstrumentsMade(
//   from: _InstrumentInput!
//   to: _OrganisationInput!
// ): _RemoveOrganisationInstrumentsMadePayload
// AddOrganisationEquipmentMade(
//   from: _EquipmentInput!
//   to: _OrganisationInput!
// ): _AddOrganisationEquipmentMadePayload
// RemoveOrganisationEquipmentMade(
//   from: _EquipmentInput!
//   to: _OrganisationInput!
// ): _RemoveOrganisationEquipmentMadePayload
// AddOrganisationPaymentsMade(
//   from: _OrganisationInput!
//   to: _PaymentInput!
// ): _AddOrganisationPaymentsMadePayload
// RemoveOrganisationPaymentsMade(
//   from: _OrganisationInput!
//   to: _PaymentInput!
// ): _RemoveOrganisationPaymentsMadePayload
// AddOrganisationPaymentsReceived(
//   from: _PaymentInput!
//   to: _OrganisationInput!
// ): _AddOrganisationPaymentsReceivedPayload
// RemoveOrganisationPaymentsReceived(
//   from: _PaymentInput!
//   to: _OrganisationInput!
// ): _RemoveOrganisationPaymentsReceivedPayload
